import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Reposiciona a página no topo a cada navegação.
 *
 * O navegador não faz isso sozinho numa SPA: trocar de rota é trocar o conteúdo de um documento que
 * continua o mesmo, e a barra de rolagem fica onde estava. Quem sai do fim de uma lista longa e
 * clica noutra área do menu cai no MEIO da tela nova.
 *
 * O projeto já resolvia isso com `window.scrollTo(0, 1)` no efeito de montagem de cada tela — em 15
 * arquivos. Toda tela nova precisa lembrar da linha, e nove delas não lembraram (as do estoque, as
 * de cotação e as duas do cancelamento). Este componente é a mesma regra num lugar só, e passa a
 * valer também para as telas que ainda não existem.
 *
 * **Voltar não reposiciona.** Navegação `POP` — botão voltar/avançar do navegador — preserva onde a
 * pessoa estava, que é o que ela espera ao voltar de um hotel para a lista de resultados. Só a
 * navegação nova (`PUSH`/`REPLACE`) vai ao topo.
 *
 * `useLayoutEffect` e não `useEffect`: o reposicionamento acontece antes da pintura, então não há o
 * flash de ver a tela nova rolada e ela pular em seguida.
 *
 * Não renderiza nada — deve ser montado dentro do Router, uma vez por layout.
 */
const ScrollToTop = () => {
	const { pathname } = useLocation();
	const navigationType = useNavigationType();

	useLayoutEffect(() => {
		if (navigationType === 'POP') return;
		window.scrollTo(0, 0);
	}, [pathname, navigationType]);

	return null;
};

export default ScrollToTop;
